// extracted by mini-css-extract-plugin
export default {"samlForm":"samlForm---LCw2o"};